import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames'
import SelectFieldEditor from '../select-field-editor/SelectFieldEditor.jsx';

// import s from './BulkChangeConfigurator.module.scss'

/**
 * The ChangeTypeSelector add the options for the dropdown in Bulk Editor for bulk actions
 *
 * Static Labels and Buttons
 * @param {string} value: the action that is chosen
 * @param {function} onChange: Checks for changes in the dropdown
 * @param {array} options: the label and value property types
 *
 */

export default class BulkTextField extends Component {
    static propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.string,
            }),
        ),
    };

    static defaultProps = { onChange: () => {} };

    static makeOptions = targetName => [
        // Dropdown make target name
        { label: '---', value: null },
        { label: `Replace ${targetName}`, value: 'REPLACE' },
        { label: `Delete ${targetName}`, value: 'DELETE' },
    ];

    /**
     * Calls onChange with the bulk action string
     *
     */
    onValueSelected = newValue => {
        this.props.onChange(newValue);
    };

    render() {
        const { value, options } = this.props;
        return <SelectFieldEditor selectedValue={value} options={options} onValueSelected={this.onValueSelected} />;
    }
}
